
        module.exports = __webpack_public_path__ + "assets/images/fod-en-2023.6bb34209.svg";;

        var src = '' + module.exports;

        module.exports = {

            src: src,
            width: 194,
            height: 61,
            type: "svg",
            bytes: 17080,

            toString: function() {
                return src;
            }
        };
    